import ReactDOM from "react-dom";
import { UseFormReturn } from "react-hook-form";
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import { comuneCapMap } from "../../../../../lib/places/cap";
import { regions } from "../../../../../lib/places/italianRegions";
import { provinceComuniMap } from "../../../../../lib/places/listaComuni";
import { RotateIcon } from "../../../../../ui/icons/rotate";
import Button from "../../../../../ui/molecules/button";
import { UpdateCompanyFormValues } from "./validation";

export function CalculateLocationTooltip({ form }: { form: UseFormReturn<UpdateCompanyFormValues> }) {
    const {
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible,
    } = usePopperTooltip(
        {
            placement: 'auto',
        },
    );
    const zipCode = form.watch("zipCode");

    return (
        <div>
            <div ref={setTriggerRef}>
                <Button
                    icon={<RotateIcon color={""} size={0} />}
                    size={"md"}
                    iconPosition={"only"}
                    variant={"link"}
                    color={"gray"}
                    onClick={() => {
                        const cities = Array.from(comuneCapMap.entries()).filter(([_, cap]) => cap.filter(c => c === zipCode?.toString())?.[0] ?? '');
                        if (cities.length === 0 || !cities) {
                            form.setValue("city", null);
                            form.setValue("province", null);
                            form.setValue("countryRegion", null);
                            form.setValue("state", null);
                            return;
                        }
                        if (cities.length > 0) {
                            if (cities.length === 1)
                                form.setValue("city", cities[0][0]);
                            else
                                form.setValue("city", null);
                            const province = Array.from(provinceComuniMap.entries()).find(([_, comuni]) => comuni.includes(cities[0][0]));
                            if (province) {
                                form.setValue("province", province[0]);
                            }
                            const region = regions.find(region => region.provinces.some(prov => prov.code === province![0]));
                            if (region) {
                                form.setValue("countryRegion", region.name);
                            }
                            form.setValue("state", "Italia");
                        }
                    }}
                />
            </div>
            {visible && ReactDOM.createPortal(
                <div
                    ref={setTooltipRef}
                    {...getTooltipProps({ className: 'tooltip-container', style: { borderRadius: 6, padding: 12, border: 0, backgroundColor: 'hsla(0, 0%, 96%, 1)', maxWidth: '200px' } })}
                >
                    <div className="flex flex-col bg-neutral-50 text-neutral-600 font-medium text-text-xs">
                        Clicca per calcolare il comune, la provincia, la regione e lo stato in base al CAP inserito.
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
}
